import { getImagesArray } from '../../hooks/useImagesArray';
import ImageViewer from '../ImageViewer';
import { LocationAndCraneCoverageWrapper } from './styles';

const LocationAndCraneCoverage = ({ images }) => {
  const { imageArray } = getImagesArray(images || [], 10);

  return (
    <LocationAndCraneCoverageWrapper>
      <ImageViewer
        imageId={imageArray[8].imageId}
        containerStyle={{
          width: '100%',
          height: '300px',
        }}
      />
    </LocationAndCraneCoverageWrapper>
  );
};

export default LocationAndCraneCoverage;
